"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FilePondStatus;
(function (FilePondStatus) {
    FilePondStatus[FilePondStatus["EMPTY"] = 0] = "EMPTY";
    FilePondStatus[FilePondStatus["IDLE"] = 1] = "IDLE";
    FilePondStatus[FilePondStatus["ERROR"] = 2] = "ERROR";
    FilePondStatus[FilePondStatus["BUSY"] = 3] = "BUSY";
    FilePondStatus[FilePondStatus["READY"] = 4] = "READY";
})(FilePondStatus || (FilePondStatus = {}));
;
var FileHelp = /** @class */ (function () {
    function FileHelp() {
    }
    FileHelp.toFileId = function (f) {
        return f.serverId;
    };
    FileHelp.statusBusy = function (s) {
        return s === FilePondStatus.BUSY;
    };
    return FileHelp;
}());
exports.default = FileHelp;
//# sourceMappingURL=fileHelp.js.map